const routes = [
    {
        path: '/assinatura_digital/contatos',
        alias: ['/assinatura_digital/contatos/index'],
        component: () => import('../views/Listar')
    },
    {
        path: '/assinatura_digital/contatos/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        path: '/assinatura_digital/contatos/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        path: '/assinatura_digital/contatos/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
    {
        path: '/assinatura_digital/contatos/importar_cadastros',
        component: () => import('../views/Importar')
    }
]

export default routes